import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { setCaptchaErrorModalVisibleAction } from 'redux/actions/modal.action';
import { RootReducersState } from 'redux/reducers';
import { IProps } from 'components/CaptchaErrorModal/types';
import Modal from 'components/Modal';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';

const CaptchaErrorModal: React.FC<IProps> = (props) => {
  const handleConfirm = () => {
    handleClose();
  };

  const handleClose = () => {
    props.setCaptchaErrorModalVisible(false);
  };

  return (
    <>
      {props.modal.captchaErrorModalVisible && (
        <Modal
          visible={props.modal.captchaErrorModalVisible}
          icon={SweetAlertIcon.Info}
          title="驗證碼錯誤"
          cancelButton={false}
          closeIcon={false}
          onConfirm={handleConfirm}
          onCancel={handleClose}
        >
          <p className="element__part">剩餘 <span>3</span> 次機會</p>
        </Modal>
      )}
    </>
  );
};

const mapStateToProps = (state: RootReducersState) => ({
  modal: state.modal
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setCaptchaErrorModalVisible: (visible: boolean) => dispatch(setCaptchaErrorModalVisibleAction(visible))
});

export default connect(mapStateToProps, mapDispatchToProps)(CaptchaErrorModal);
